import Action from '../actions'
import AppMessage from "../../app-config"

export function setPublicConfigAction(sysConfig) {
    return {
        type: Action.PUBLIC_SYSTEM_CONFIGURATION,
        sysConfig
    }
}

export function handlePublicConfigAction(error) {
    let statusCode = error.request ? error.request.status : 0;
    if (!error.request) {
        error = 'Network error!'
    }
    if (statusCode === 401) {
        alert(AppMessage.UNAUTHORIZED_ERROR);
    }
    if (statusCode === 200) {
        alert(AppMessage.PUB_SYS_CONFIG_ERROR);
    }
    return {
        type: Action.PUBLIC_SYSTEM_CONFIGURATION_ERROR,
        error: error.request ? error : "Network error!"
    }
}



